import Big from "big.js"
import { Combobox, InputDate, CustomTable, formatCurrency, InputTextCustom, EInputTypes, Steps } from "medere-ui-framework"
import { Button } from "primereact/button"
import { Column } from "primereact/column"
import { useState, useMemo, useEffect, ChangeEvent, useRef } from "react"
import { OrderId, PaymentArray, usePaymentOrder } from "../../components/context/PaymentOrderContext"
import { MAX_DECIMAL } from "../../interface/orderOfProvision"
import { AdminFormDTO, AdministrativeForm } from "../../interface/interface"
import { usePaymentOrdersService } from "../../servicesHooks/PaymentOrders/usePaymentOrdersService"
import { useSupplierService } from "../../servicesHooks/Supplier/useSupplierService"

function Items() {
    const { getAllPaymentOrders } = usePaymentOrdersService();
    const { getAllSuppliersWithBalance } = useSupplierService();

    const { stepMovement, supplier, setSupplier, sinceDate, untilDate, setUntilDate, steps, setSinceDate, invoices, setInvoices, paymentArray, setPaymentArray } = usePaymentOrder()

    const tableRef = useRef<any>(null)
    const [totalToPay, setTotalToPay] = useState(Big(0))

    const totalOwed = useMemo(() => {
        if (supplier?.balance) {
            return new Big(supplier.balance * -1)
        } else {
            return new Big(0)
        }
    }, [supplier])

    useEffect(() => {
        if (supplier?.lastpendingdate) {
            const _dateWithoutHours = new Date(supplier?.lastpendingdate)
            _dateWithoutHours.setHours(0, 0, 0, 0)
            setSinceDate(_dateWithoutHours)
        }
    }, [supplier])

    useEffect(() => {
        const _paymentArray = [...paymentArray]
        invoices.forEach((item:any) => {

            const exists = _paymentArray.find((i) => i.orderId == `${item.posnumber}|${item.formnumber}` && i.paymentValue === item.amount)

            if (!exists) {
                _paymentArray.push({
                    orderId: `${item.posnumber}|${item.formnumber}`,
                    paymentValue: item.amount,
                    paymentToPay: 0
                })
            }
        })

        const filteredPaymentArray = _paymentArray.filter((payment) =>
            invoices.some((item:any) => payment.orderId == `${item.posnumber}|${item.formnumber}` && payment.paymentValue === item.amount)
        )
        setPaymentArray(filteredPaymentArray)
    }, [invoices]);

    function onChangePaymentToPay(value:number | undefined, maxAmount:number, item: PaymentArray) {
        const copyArray = [...paymentArray]
        const index = copyArray.findIndex(x => x.orderId == item.orderId && x.paymentValue == item.paymentValue)

        let newPaymentToPay = !isNaN(Number(value)) ? Number(value) : 0
        newPaymentToPay = newPaymentToPay > maxAmount ? maxAmount : newPaymentToPay
        
        if (index === -1) return
        copyArray[index].paymentToPay = newPaymentToPay
        setPaymentArray(copyArray)
    }

    useEffect(() => {
        setTotalToPay(paymentArray.reduce((acc, curr) => acc.plus(curr.paymentToPay), new Big(0)))
    }, [paymentArray])

    function getPaymentOrders(offSet: number, pageSize: number, params?: any) {
        return getAllPaymentOrders(offSet, pageSize, params).then((resp) => {
            return resp.map((item => {
                const listAfRelated = item.afrelatedstr?.split(',').map((afrelated:any) => {
                    const [receipttype, date, amount, posnumber, formnumber] = afrelated.split(' - ')
                    const formatedFormnumber = formnumber.split(' / ')[0]
                    return {
                        receipttype,
                        date,
                        amount,
                        concept: `Asociada a ${item.receipttype + ' ' + item.formnumber + '-' + item.posnumber}`,
                        posnumber,
                        formnumber: formatedFormnumber
                    }
                })
                return {
                    ...item,
                    afrelated: listAfRelated,
                }
            }))
        })
    }

    return (
        <>
            <Steps steps={steps} activeStep={stepMovement.stepIndex} labelStyle={{ color: '#01717C', fontSize: '16px', fontWeight: '500' }} />
            <h2 className="title font-semibold text-lg">Proveedores</h2>
            <section className="payment-order-items-grid">
                <Combobox
                    getItems={getAllSuppliersWithBalance}
                    optionLabel="commercialname"
                    value={supplier}
                    setValue={setSupplier}
                    placeholder="Seleccionar"
                    label="Nombre"
                />
                <InputDate
                    label="Periodo desde"
                    placeholder="dd/mm/aaaa"
                    value={sinceDate}
                    onChange={(e) => {
                        setInvoices([])
                        setSinceDate(e.target.value)
                    }}
                    className="mt-3"
                />

                <InputDate
                    label="Periodo hasta"
                    placeholder="dd/mm/aaaa"
                    value={untilDate}
                    onChange={(e) => {
                        setInvoices([])
                        setUntilDate(e.target.value)
                    }}
                    className="mt-3"
                />

                {/*<Button
                    label="Ver cuenta corriente"
                    className="buttonMain3 w-full"
                />*/}
            </section>
            {supplier?.paymentconditiondesc && <p className="italic font-sans my-2">{supplier?.paymentconditiondesc}</p>}
            <CustomTable
                idTable="paymentOrdersTable"
                ref={tableRef}
                getItems={getAllPaymentOrders}
                resizableColumns
                hideFiltersButton
                filterRow={false}
                selectionMode="checkbox"
                selectedItems={invoices}
                className="paymentOrdersTable"
                containerClassName="paymentOrdersContainer"
                onSelectionChange={(e) => setInvoices(e.value)}
                params={{
                    supplierId: supplier?.medereentity,
                    sinceDate: sinceDate?.toISOString(),
                    untilDate: untilDate?.toISOString()
                }}
            >
                <Column header="Fecha" body={(e) => {
                    if (e.date) {
                        const date = new Date(e.date).toLocaleDateString()
                        if (e.afrelated?.length > 0) {
                            return <div className="flex flex-column gap-3">
                                <p>{date}</p>
                                {e.afrelated.map((af:any) => <p>{new Date(af.date).toLocaleDateString()}</p>)}
                            </div>
                        }

                        return date
                    }
                    return ''
                }} field="date " />
                <Column header="Tipo" field="receipttype" body={(e) => {
                    if (e.receipttype) {
                        if (e.afrelated?.length > 0) {
                            return <div className="flex flex-column gap-3">
                                <p>{e.receipttype}</p>
                                {e.afrelated.map((af:any) => <p>{af.receipttype}</p>)}
                            </div>
                        }
                        return e.receipttype
                    }
                    return ''
                }} />
                <Column header="Nº" field="formnumber" body={(e) => {
                    if (e.formnumber) {
                        return <div className="flex flex-column gap-3">
                            <p>{e.formnumber}</p>
                            {e.afrelated?.map((af:any) => <p>{af.formnumber}</p>)}
                        </div>
                    }
                    return ''
                }} />
                <Column header="Concepto" body={(e:AdminFormDTO) => {
                    return <div className="flex flex-column gap-3">
                        <p>{e?.observations != null && e?.observations.trim() != '' ? e.observations : 'No posee descripción'}</p>
                    </div>
                }} />
                <Column header="PV" field="posnumber" body={(e) => {
                    if (e.posnumber) {
                        return <div className="flex flex-column gap-3">
                            <p>{e.posnumber}</p>
                            {e.afrelated?.map((af:any) => <p>{af.posnumber}</p>)}
                        </div>
                    }
                }} footer={<div>
                    <p className="text-lg">Total adeudado</p>
                    <p className="title text-lg font-semibold uppercase">Total a pagar</p>
                </div>} />
                <Column header="Importe" field="amount" body={(e:AdminFormDTO) => {
                    if (e.amount) {
                        return <div className="flex flex-column gap-3">
                            <p>{`${formatCurrency(Number(e.afrelatedstr ? e.pendingamount.toFixed(2) : e.amount.toFixed(2)), {
                                currency: 'ARS',
                            })}`}</p>
                        </div>
                    }
                    return ''
                }} footer={<p className="font-bold">{
                    formatCurrency(Number(totalOwed.toFixed(2)), {
                        currency: 'ARS',
                    })
                }</p>} footerClassName="flex border-none" />
                <Column header="A pagar" className="w-40" body={(adminform:AdminFormDTO) => {
                    const item = paymentArray.find((i) => i.orderId == `${adminform.posnumber}|${adminform.formnumber}` && i.paymentValue === adminform.amount)
                    if (item && item.paymentToPay == 0) {
                        item.paymentToPay = adminform.pendingamount ?? 0
                    }

                    if (item) {
                        return <InputTextCustom
                            inputType={EInputTypes.NUMBER}
                            max={adminform.amount}
                            minFractionDigits={2}
                            value={Number(item.paymentToPay)}
                            onChange={(e) => onChangePaymentToPay(e.target.value, adminform.amount, item)}
                        />
                    }
                    return ''
                }} footer={<p className="title text-lg font-semibold uppercase ">
                    {formatCurrency(Number(totalToPay), {
                        currency: 'ARS',
                        maximumFractionDigits: MAX_DECIMAL
                    })}</p>
                } footerClassName="align-bottom" />
                <Column header="Vencimiento" body={() => ''} />
            </CustomTable>
            <div className="flex flex-end align-items-end flex-grow">
                <Button className="buttonMain2 capitalize" label="volver" iconPos="left" icon="pi pi-chevron-left" onClick={stepMovement.prevStep} />
                <Button className="buttonMain capitalize" label="seguir" iconPos="right" icon="pi pi-chevron-right" onClick={stepMovement.nextStep} disabled={!supplier || invoices?.length <= 0} />
            </div>
        </>
    )
}

export default Items
